import React from "react";
import styles from "./AboutUsM.module.css";

export default function AboutUs() {
  return <div className="darkSectionContent" id="aboutUs">
      <div className="lightSectionTitle">
        <h1>Poznaj nas</h1>
      </div>
      <div className={styles.sectionDescription}>
        <p>
          Jesteśmy zespołem, który chętnie zadba o Twój samochód. Nasza praca
          łączy się z pasją do motoryzacji. W naszej pracy chętnie korzystamy
          z nowoczesnych rozwiązń technicznych. Każdego klienta oraz jego auto
          traktujemy indywidualnie, dbając o to, aby naprawy były szybkie,
          skuteczne i trwałe.
        </p>
        <p>
          Dla nas najważniejsze jest bezpieczeństwo i komfort naszych
          klientów. Dlatego nie tylko naprawiamy samochody, ale
          też doradzamy, jak dbać o pojazd, by służył jak najdłużej.
        </p>
      </div>
    </div>;
}
